import { useEffect } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { hasUserAuthCookies } from "@/routes/SignIn"
import { getSharedRouteId, plannerPath } from "@/lib/appEntryLink"
import AnalyzeOrderOnPage from "./AnalyzeOrderOnPage"

const RedirectToApp = ({ routeId }: { routeId: string | null }) => {
  useEffect(() => {
    window.analytics?.track("Anonymous_RedirectToApp", {
      reason: routeId ? "logged_in_shared_route" : "logged_in_no_shared_route",
      routeId,
    })
  }, [routeId])

  return <Navigate to={plannerPath(routeId)} replace />
}

const AnalyzeOrderOnPageEntry = () => {
  const { search } = useLocation()

  if (hasUserAuthCookies()) {
    return <RedirectToApp routeId={getSharedRouteId(search)} />
  }

  return <AnalyzeOrderOnPage />
}

export default AnalyzeOrderOnPageEntry
